import { useState } from "react";
import { homeService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { IBidPricingResponse } from "@miplatform/types";
import { useCreateBidContext } from "../../../CreateBidContext";

export const useDrawsSummaryViewModel = () => {
  const [priceDetails, setPriceDetails] = useState<IBidPricingResponse | null>(
    null
  );

  const { form } = useCreateBidContext();
  const { watch } = form;
  const { builderId, planAreas } = watch();

  const getPriceDetails = async () => {
    const response = await homeService.pricing.plans.getById({
      planAreas,
      accountId: builderId,
    });
    if (response.status === HTTP_STATUSES.OK) {
      setPriceDetails(response.data.planDetails);
    }
  };

  return {
    planAreas,
    priceDetails,
    getPriceDetails,
  };
};
